import script from "./OutreachDrafts.vue?vue&type=script&setup=true&lang=js"
export * from "./OutreachDrafts.vue?vue&type=script&setup=true&lang=js"

import "./OutreachDrafts.vue?vue&type=style&index=0&id=29cf0896&scoped=true&lang=css"

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29cf0896"]])

export default __exports__